import * as c from '@chakra-ui/react'
import { TranslateOptions, translateText } from 'src/utils/translateText'

import { ExternalLinkIcon } from '../icons/external-link.icon'
import { PiggyBankIcon } from '../icons/piggy-bank.icon'

interface LimitedOfferProps {
  limitedOfferBanner: {
    bannerImage: string
    partnerLogo: string
    partnerName: TranslateOptions
    partnerDescription: TranslateOptions
    url: string
    idSection?: string
  }
}

export default function LimitedOffer({
  limitedOfferBanner,
}: LimitedOfferProps) {
  return (
    <c.Container px={['s5', 0]} id={limitedOfferBanner?.idSection}>
      <c.Flex
        direction={['column', 'row']}
        border={['2px solid', 'none']}
        borderColor={['primary.200', 'none']}
        borderRadius="20px"
      >
        <c.Image
          src={limitedOfferBanner?.bannerImage}
          alt={translateText(limitedOfferBanner?.partnerName) as string}
          position="relative"
          h={['120px', '162px']}
          w={['full', '760px']}
          objectFit="cover"
          borderRadius={['20px 20px 0 0', '20px 0 0 20px']}
        />

        <c.Flex
          position="absolute"
          py="s1"
          px="s3"
          m="s5"
          bg="primary.500"
          borderRadius="full"
          align="center"
          gap="s1"
        >
          <c.Icon as={PiggyBankIcon} color="black.0" h="22px" w="22px" />
          <c.Text
            color="black.0"
            fontSize="t-sm.0"
            fontWeight="bold"
            textTransform="uppercase"
          >
            {translateText({ ptBr: 'oferta appspace', en: 'appspace offer' })}
          </c.Text>
        </c.Flex>

        <c.Flex
          as={c.Link}
          isExternal
          href={limitedOfferBanner?.url}
          py={['s4', 0]}
          px={['s4', 'l2']}
          bg="primary.50"
          border={['none', '2px solid']}
          borderColor={['none', 'primary.200']}
          borderRadius={['0 0 20px 20px', '0 20px 20px 0']}
          align="center"
          gap="s4"
        >
          <c.Image
            src={`${limitedOfferBanner?.partnerLogo}`}
            alt={translateText(limitedOfferBanner?.partnerName) as string}
            h={['60px', '80px']}
            w={['60px', '80px']}
            objectFit="cover"
            borderRadius="8px"
          />

          <c.Box maxW={['full', '220px']}>
            <c.Heading color="primary.500" size="sm">
              {translateText(limitedOfferBanner?.partnerName)}
            </c.Heading>
            <c.Text>
              {translateText(limitedOfferBanner?.partnerDescription)}
            </c.Text>
          </c.Box>

          <c.IconButton
            icon={
              <c.Icon
                as={ExternalLinkIcon}
                color="primary.500"
                h="26px"
                w="26px"
              />
            }
            aria-label=""
            size="sm"
            bg="primary.100"
            _hover={{
              bg: 'primary.200',
            }}
          />
        </c.Flex>
      </c.Flex>
    </c.Container>
  )
}
